"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-ten/sections/teamSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TeamSection36FadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "doctor" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    className?: string;
    /** Detected variants: "/Templates/Doccure/img/team/team-img-1.png" */
    src?: string;
    /** Detected variants: "all_routes.doctorProfile1" */
    href?: string;
    /** Detected variants: "doctor" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "/Templates/Doccure/img/team/team-img-2.png" | "/Templates/Doccure/img/team/team-img-4.png" | "/Templates/Doccure/img/team/team-img-3.png" */
    imageWithBasePath0Src?: string;
    /** Detected variants: "Dr. Diana Williams" | "Dr. Ryan Elliott" | "Dr. Elizabeth Yates" | "Dr. William Altman" */
    link0Text: ReactNode;
    /** Detected variants: "Embryologist" | "Cryobiologist" | "Gynecologist" | "Andrologist" */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-md-6 d-flex wow fadeInUp" */
    divClassName?: string;
    /** Detected variants: "0.2s" */
    dataWowDelay?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "team-item-ten flex-fill" */
    div0ClassName?: string;
    /** Detected variants: "team-img" */
    div0ClassName2?: string;
    /** Detected variants: "team-icon" */
    div0ClassName3?: string;
    /** Detected variants: "icon" */
    imageWithBasePath0Alt2?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/fertility.svg" */
    imageWithBasePath0Src2?: string;
    /** Detected variants: "team-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.doctorProfile1" */
    link0Href?: string;
};
export type HomeTenTeamSectionGeneratedProps = {
    divDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection36FadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection36FadeInUpsItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection36FadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "Doctors" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Meet Our Fertility Specialists" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    sectionDiv0Div1ClassName?: string;
    teamSection36FadeInUps: TeamSection36FadeInUpsItem[];
    teamSection36FadeInUpsItemWrapper?: (item: TeamSection36FadeInUpsItem, content: ReactNode) => ReactNode;
    teamSection36FadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSection36FadeInUpsLinkVisible?: boolean;
    teamSection36FadeInUpsLinkRenderer?: (item: TeamSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    teamSection36FadeInUpsImageVisible?: boolean;
    teamSection36FadeInUpsImageRenderer?: (item: TeamSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    teamSection36FadeInUpsH3Visible?: boolean;
    teamSection36FadeInUpsH3Renderer?: (item: TeamSection36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    teamSection36FadeInUpsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection36FadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    teamSection36FadeInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    teamSection36FadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection36FadeInUpsItem) => Partial<ComponentProps<"h3">>);
};

const HomeTenTeamSectionGenerated: FC<HomeTenTeamSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Doctors",
    sectionDiv0Div0H20H2Text = "Meet Our Fertility Specialists",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    divDiv0Div0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    teamSection36FadeInUps,
    teamSection36FadeInUpsItemWrapper,
    teamSection36FadeInUpsRenderer,
    teamSection36FadeInUpsLinkVisible,
    teamSection36FadeInUpsLinkRenderer,
    teamSection36FadeInUpsImageVisible,
    teamSection36FadeInUpsImageRenderer,
    teamSection36FadeInUpsH3Visible,
    teamSection36FadeInUpsH3Renderer,
    teamSection36FadeInUpsLinkProps,
    teamSection36FadeInUpsImageProps,
    teamSection36FadeInUpsH3Props,
}) => {
    return (
        <section className="team-section-ten section">
            <div className="container">
                <div className="section-header section-header-ten">
                    <div className="section-sub-title">
                        <span className="sec-circle" aria-hidden="true" />
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        teamSection36FadeInUps,
                        (item: TeamSection36FadeInUpsItem) => (
                            <div className={item.divClassName ?? "col-xl-3 col-md-6 d-flex wow fadeInUp"} data-wow-delay={item.dataWowDelay ?? "0.2s"} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                                <div className={item.div0ClassName ?? "team-item-ten flex-fill"}>
                                    <div className={item.div0ClassName2 ?? "team-img"}>
                                        {renderItemNode(teamSection36FadeInUpsLinkVisible, teamSection36FadeInUpsLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "#"} {...(typeof teamSection36FadeInUpsLinkProps === "function" ? teamSection36FadeInUpsLinkProps(item) : (teamSection36FadeInUpsLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                {renderItemNode(teamSection36FadeInUpsImageVisible, teamSection36FadeInUpsImageRenderer, item, (
                                                    <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt} className={item.imageWithBasePath0ClassName} {...(typeof teamSection36FadeInUpsImageProps === "function" ? teamSection36FadeInUpsImageProps(item) : (teamSection36FadeInUpsImageProps ?? {}))} {...(typeof divDiv0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                        <div className={item.div0ClassName3 ?? "team-icon"}>
                                            {renderItemNode(teamSection36FadeInUpsImageVisible, teamSection36FadeInUpsImageRenderer, item, (
                                                <SmartImage src={item.imageWithBasePath0Src2 ?? "/Templates/Doccure/img/icons/fertility.svg"} alt={item.imageWithBasePath0Alt2 ?? "icon"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid"} {...(typeof teamSection36FadeInUpsImageProps === "function" ? teamSection36FadeInUpsImageProps(item) : (teamSection36FadeInUpsImageProps ?? {}))} {...(typeof divDiv0Div0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                    </div>
                                    <div className={item.div1ClassName ?? "team-content"}>
                                        {renderItemNode(teamSection36FadeInUpsH3Visible, teamSection36FadeInUpsH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof teamSection36FadeInUpsH3Props === "function" ? teamSection36FadeInUpsH3Props(item) : (teamSection36FadeInUpsH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(teamSection36FadeInUpsLinkVisible, teamSection36FadeInUpsLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href ?? "all_routes.doctorProfile1"} {...(typeof teamSection36FadeInUpsLinkProps === "function" ? teamSection36FadeInUpsLinkProps(item) : (teamSection36FadeInUpsLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        teamSection36FadeInUpsItemWrapper,
                        teamSection36FadeInUpsRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeTenTeamSectionGenerated;
